import api from '../../services/supplement';
export default function (helper) {

  /**
   * Generated store module
   */
  helper.setApi(api);
  const types = helper.types('supplement');
  const state = helper.state();
  const getters = helper.getters();
  const actions = helper.actions({}, 'Supplement');
  const mutations = helper.mutations({}, types, state);

  return {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };
}